import React from "react";
import Skeleton from "react-loading-skeleton";

const CurriculumSkeleton = () => {
  return (
    <div className="row px-3 px-md-0">
      {Array.from(Array(3).keys()).map((e, i) => (
        <div className="block-box" key={i}>
          <div className="skeleton-wrapper-bottom">
            <Skeleton className="mark1" height={10} width={150} />
          </div>
          <div className="skeleton-wrapper-top">
            <Skeleton className="mark2" height={30} width={150} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default React.memo(CurriculumSkeleton);
